module.exports = __webpack_public_path__ + "static/media/ic_line_selected.5acf5064.svg";